import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router";
import Image from "common/components/image";

const Cta2 = ({ background }) => {
  return (
    <section className={cn("block block-cta-2", background)}>
      <div className="row">
        <div className="columns small-16">
          <div className="box">
            <h2>Design Boldly. Brand Brilliantly.</h2>
            <p>
              It's easy to get started. And it's guaranteed.
              <br className="show-for-medium" /> Two things everyone loves.
            </p>
            <Link to="/categories/" className="btn btn-primary">
              Explore design categories
            </Link>
            <Image
              src="fastlane-ad-graphic-2.png"
              widths={[500]}
              alt="Design Boldly. Brand Brilliantly."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

Cta2.propTypes = {
  background: PropTypes.string,
};

export default Cta2;
